import { ensureGtmDataLayer, trackPageView as gtmTrackPageView } from "./gtm";
import { ensureAnonymousUuid, ensureDeviceUuid } from "./identity";
import { SYNC_RETRY_ATTEMPT_MAX, scheduleSynchronization as schedulePendoSync } from "./pendo";
import { scheduleUuidSync, syncPage as segmentSyncPage } from "./segment";
import { trackAnalyticsSession } from "./session";
import { evaluateUtmData } from "./utm";

const shouldEnableAnalytics = () => {
  if (typeof window !== "undefined" && window?.navigator?.userAgent?.match(/FeatherTest/i)) {
    return false;
  }

  return true;
};

export function onPageChange() {
  if (shouldEnableAnalytics()) {
    schedulePendoSync(SYNC_RETRY_ATTEMPT_MAX);
    trackAnalyticsSession();
    scheduleUuidSync();
    segmentSyncPage();
    gtmTrackPageView();
  }
}

export function initializeTracking() {
  if (shouldEnableAnalytics()) {
    ensureAnonymousUuid();
    ensureDeviceUuid();
    evaluateUtmData();
    ensureGtmDataLayer();
    onPageChange();
  }
}
